import { useMagicMenuStore } from './magicMenuStore';
import type { MagicMenuItem } from './types';

/** Read-only přístup k menu položkám doručeným z Magic control instance. */
export function useMagicMenu(): {
  readonly items: readonly MagicMenuItem[];
  readonly isReady: boolean;
  /** Načítání plochy Magicu selhalo (pojistka proti zacyklení) → místo spinneru zobrazit chybu. */
  readonly loadError: boolean;
} {
  const items = useMagicMenuStore((s) => s.items);
  const isReady = useMagicMenuStore((s) => s.isReady);
  const loadError = useMagicMenuStore((s) => s.loadError);
  return { items, isReady, loadError };
}
